import axios, { type AxiosInstance } from "axios"

/**
 * For pages opened without an account: unlike `api.ts`, it sends no stored
 * login token and never turns a 401 into a sign-out.
 */
export const publicApi: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_ROUTE,
  headers: { "Content-Type": "application/json" },
  // Anything but 5xx is an answer these pages render: a refusal has a reason.
  validateStatus: (status: number) => status < 500
})
